(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("SourceView", [], factory);
	else if(typeof exports === 'object')
		exports["SourceView"] = factory();
	else
		root["SourceView"] = factory();
})(window, function() {
return 